'use strict';

var ROLE_NAV = {
  'Page Order': [],
};

module.exports = ROLE_NAV;
